/**
 * The garage behind the catalogue: a shop light and a steel shelf of boxes.
 *
 * Decoration only, so it is hidden from assistive technology and carries no
 * facts. It is plain markup drawn by garage.css: no script, no images, and no
 * inline styles (the storefront CSP forbids style attributes). Box labels are
 * real text in the marker face so they stay sharp at every size.
 */

import type { ReactNode } from "react";

export function ShopLight(): ReactNode {
  return (
    <div aria-hidden="true" className="shop-light">
      <span className="shop-light-chain shop-light-chain--left" />
      <span className="shop-light-chain shop-light-chain--right" />
      <span className="shop-light-fixture">
        <span className="shop-light-tube" />
      </span>
    </div>
  );
}

export function GarageShelf(): ReactNode {
  return (
    <div aria-hidden="true" className="garage-shelf">
      <span className="cord" />
      <div className="shelf-unit">
        <div className="shelf-level">
          <span className="box box--n64">
            <span className="box-label">N64</span>
          </span>
          <span className="box box--gameboy">
            <span className="box-label">Game Boy</span>
          </span>
          <span className="tote">
            <span className="tote-lid" />
          </span>
        </div>
        <div className="shelf-level">
          <span className="box box--ps1">
            <span className="box-label">PS1 games</span>
          </span>
          <span className="box box--cables">
            <span className="box-label">Cables??</span>
          </span>
        </div>
        <div className="shelf-level">
          <span className="box box--misc">
            <span className="box-label">Misc</span>
          </span>
          <span className="box box--keep">
            <span className="box-label box-label--tape">Do not sell</span>
          </span>
          <span className="can" />
        </div>
      </div>
    </div>
  );
}
